import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const IconChevronDownSolid = /*#__PURE__*/ forwardRef(({ title, titleId, size = 24, ...props }, ref)=>{
    return jsxs("svg", {
        ref: ref,
        width: size,
        height: size,
        "data-testid": "icon-chevrondownsolid",
        "aria-hidden": title ? undefined : 'true',
        "aria-labelledby": titleId,
        viewBox: "0 0 20 20",
        fill: "currentColor",
        ...props,
        children: [
            title ? jsx("title", {
                id: titleId,
                children: title
            }) : null,
            jsx("path", {
                fillRule: "evenodd",
                d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414",
                clipRule: "evenodd"
            })
        ]
    });
});
IconChevronDownSolid.displayName = 'IconChevronDownSolid';

export { IconChevronDownSolid as default };
//# sourceMappingURL=IconChevronDownSolid.js.map
